import { useQuery } from 'react-query';
import eventLogService, { EventLogClinicDaily } from '../services/eventLog.service';

const useEventLogClinicDaily = (
  clinicId: number,
  startDate?: string,
  endDate?: string,
  userId?: string
) => {
  const { status, data, error, isFetching, refetch } = useQuery<EventLogClinicDaily>(
    ['eventLogClinicDaily', clinicId, startDate, endDate, userId],
    () => eventLogService.getClinicDaily(clinicId, { startDate, endDate, userId }),
    {
      refetchOnWindowFocus: false,
      enabled: !!clinicId,
      keepPreviousData: true,
    }
  );

  return {
    status,
    data,
    error,
    isFetching,
    refetch,
  };
};

export default useEventLogClinicDaily;
